<template>
  <v-card
      flat
      class="mx-auto"
      max-width="800"
      mim-width="350"
  >
    <v-breadcrumbs :items="tags" class="text-grey-darken-2 font-weight-bold text-body-2" densit="compact">
      <template v-slot:divider>/</template>
      <template v-slot:title="{ item }">
        {{ item.title }}
      </template>
    </v-breadcrumbs>

    <v-card v-if="upjangInfo.upjang_info" class="bg-grey-lighten-4 mx-auto mt-2 ml-3 mr-3" flat>
      <v-card-text>
        {{ upjangInfo.upjang_info }}
      </v-card-text>
    </v-card>

    <v-tabs
        class="ml-3 mr-3"
        show-arrows
        v-model="activeTab"
        slider-color="primary">
      <v-tab
          class="font-weight-bold"
          v-for="tab in tabs"
          :value="tab.code"
          @click="getMenuList(tab.name)">
        {{ tab.name }}
      </v-tab>
    </v-tabs>

    <v-window v-model="activeTab" class="ma-3">
      <v-window-item
          v-for="tab in tabs"
          :value="tab.code"
      >
      </v-window-item>

      <v-card>
        <v-row v-if="!menus || menus.length < 1" dense>
          <v-col cols="12">
            <v-card-text class="mt-2 text-body-1 text-center">준비중입니다.</v-card-text>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col
              v-for="menu in menus"
              cols="12"
          >
            <v-card
                :style="'border: 1px solid #BDBDBD'"
                class="rounded-lg"
                variant="outlined"
                :disabled="menu.sold_yn === 'Y'"
                :to="`/upjang/${menu.upjang_code}/${menu.menu_code}`"
            >
              <div class="d-flex flex-no-wrap ">
                <v-avatar
                    class="ma-2"
                    size="90"
                    rounded="0">
                  <img width="90" :src="getRealImgPath(menu.image_path)" @error="getImage">
                </v-avatar>
                <div class="pa-2">
                  <v-card-text class="pa-0 font-weight-bold text-body-1">
                    {{menu.menu_name}}
                  </v-card-text>
                  <v-card-text class="pa-0 pt-1 text-body-2">{{menu.comment}}</v-card-text>
                  <v-card-text class="pa-0 pt-1 text-body-2">{{menu.menu_notice}}</v-card-text>
                  <v-card-text class="pa-0 pt-1 text-body-2">가격: {{formatAmt(menu.sale_price)}}
                    <v-chip
                        v-if="menu.sold_yn === 'Y'"
                        class="ma-0 mb-1"
                        color="red"
                        text-color="white"
                        size="x-small"
                    >
                      품절
                    </v-chip>
                  </v-card-text>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

    </v-window>

  </v-card>

  <MobileFooter></MobileFooter>
</template>

<script>
import MobileFooter from "@/components/common/MobileFooter";
import {upjang} from "@/api";
import commonStore from "@/store/common";
import authStore from "@/store/auth";
import shotUrlStore from "@/store/shotUrl";

export default {
  name: "UpjangDetail",
  components: {MobileFooter},
  data() {
    return {
      tags: [
        {
          title: '주문/구매',
          disabled: false,
          href: '/upjang',
        },
      ],
      upjangCode: '',
      isAuth: false,
      activeTab: '00',
      tabs: [],
      menus: [],
      upjangInfo: {},
    }
  },
  created() {
    this.upjangCode = this.$route.params.upjangCode
    this.isAuth = authStore.state.authInfo.token !== ''
    this.getUpjangInfo(this.$route.params.upjangCode)
    this.getMenuGroupList()
    this.getMenuList('00')
  },
  methods: {
    getUpjangInfo(upjangCode) {
      if (!upjangCode) {
        return
      }

      upjang.getUpjangInfo(commonStore.state.common.corpCode, upjangCode)
          .then(data => {
            console.log(data)
            if (data.data) {
              this.upjangInfo = data.data
              this.tags.push({
                title: this.upjangInfo.upjang_name,
                disabled: false,
                href: '/upjang/' + this.upjangInfo.upjang_code,
              })
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    getMenuGroupList() {
      upjang.getMenuGroupList(commonStore.state.common.corpCode, this.upjangCode)
          .then(data => {
            console.log(data)
            if (data.data.groups) {
              this.tabs.push({code: "00", name: "전체"})
              data.data.groups.forEach((item) => {
                this.tabs.push({code: item.upjang_mgrp_cd, name: item.upjang_mgrp_desc})
              })
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    getMenuList(code) {
      if (code === '00' || code === '전체') {
        code = ''
      }
      upjang.getMenuList(commonStore.state.common.corpCode, this.upjangCode, code)
          .then(data => {
            console.log(data)
            if (data.data.menus.length > 0) {
              this.menus = data.data.menus
              console.log(this.menus)
            } else {
              this.menus = []
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
  }
}
</script>

<style scoped>

</style>